export var openLink = function (url, navigate) {
  if (typeof window !== "undefined") {
    if (url.match(/pdf$/)) {
      window.open(url);
    } else {
      navigate(url);
    }
  }
};